<template>
  <v-card outlined :loading="loading">
    <v-card-title> <slot name="header" /> </v-card-title>
    <v-card-text>
      <div v-if="error">
        <v-alert
          v-for="(e, index) in error.data.errors"
          :key="index"
          color="error"
          dark
          dense
        >
          {{ e[0] }}
        </v-alert>
      </div>

      <language-tabs
        v-if="localOption"
        ref="languageTabs"
        v-model="localOption.translations"
        :errors="errors.get('translations')"
        #default="{ translation, index, language, on, ...other }"
        eager
      >
        <communication-options-translation-form
          :value="translation"
          :language-id="language.id"
          v-bind="other"
          v-on="on"
          @update-prop="clearErrorByName($event, `translations.${index}`)"
          @valid="setValid(`translations.${index}`, $event)"
        ></communication-options-translation-form>
      </language-tabs>

      <v-row no-gutters>
        <slot name="buttons" />
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';

export default {
  name: 'AppSettingsForm',

  components: {
    CommunicationOptionsTranslationForm: () =>
      import(
        '@/modules/communication_options/components/CommunicationOptionsTranslationsForm'
      ),
    LanguageTabs: () => import('@/modules/_global/_components/LanguageTabs')
  },

  mixins: [errors],

  props: {
    option: {
      type: Object,
      default: () => null
    }
  },

  data: () => ({
    valid: {},
    error: null,
    localOption: null
  }),

  computed: {
    loading() {
      return this.$store.getters['loading'];
    },
    isValid() {
      return Object.values(this.valid).every(i => Boolean(i));
    }
  },

  watch: {
    isValid() {
      this.$emit('isValid', this.isValid);
    },
    localOption() {
      this.$emit('setOption', this.localOption);
    }
  },

  created() {
    if (this.option !== null) {
      this.getOption();
    } else {
      this.localOption = {};
    }
  },

  methods: {
    getOption() {
      this.$store
        .dispatch('communication_options/show', this.option.id)
        .then(({ data }) => {
          this.localOption = data;
        })
        .catch(error => {
          console.log('error');
          this.error = error.response;
        });
    },

    setValid(index, value) {
      this.$set(this.valid, index, value);
    }
  }
};
</script>
